<template>
  <div class="travelCardpay">
    <template v-if="isShowLoading">
      <loading></loading>
    </template>
    <div class="ticket_wrap">
      <div>
        <template>
          <Steps
            :current="0"
            :style="{margin:'50px 10px 30px 10px'}"
          >
            <Step title="确认订单"></Step>
            <Step title="选择支付方式"></Step>
            <Step title="完成"></Step>
          </Steps>
        </template>
        <template>
          <Card :style="{padding:'10px',marginBottom:'20px'}">
            <p slot="title">
              <Icon type="ios-film-outline"></Icon>
              旅游卡信息
            </p>
            <p>订单号：{{tradeNo}}</p>
            <h3>{{info.name}}</h3>
            <div class="cardInfo">
              <p>费用包括： {{info.name?info.name+'1张':''}} </p>
              <p>
                <span>旅游卡权益:</span> {{info.descpt}}
              </p>
              <p>
                <span>旅游卡有效期:</span> {{info.periodType === 0 ? info.periodNumber + '年' : info.periodType ===1 ? info.periodNumber + '月': info.periodNumber + '天'}}
              </p>
              <p>
                <span>通用时间:</span> {{info.usePeriod == -1 ? '不限制': info.usePeriod == 0 ? '周六周日不能使用': '节假日不能使用'}}
              </p>
              <p v-if="info.timesFlag !== -1">
                <span>有效次数:</span> {{info.effectiveTimes}}
              </p>
              <p>
                <span>银行卡购买权限:</span> {{info.bankCardFlag === -1 ? '不限制' : '限制'}}
              </p>
              <p>
                <span>身份证购买权限:</span> {{info.identityCardFlag === -1 ? '不限制' : info.identityCardFlag === 0 ? '限制' : ''}}
              </p>
              <p>
                <span>包括景点:</span> {{info.scenics||''}}
              </p>
            </div>
            <div class="footer"><strong>费用明细:</strong><span :style="{color:'#ff7f0d'}">旅游卡 1张 X ¥{{info.price&&info.price.toFixed(2)}}</span> </div>
            <div class="yhamout" v-if="showCouponAmount"><strong>优惠金额：</strong><span :style="{color:'#ff7f0d'}">¥ {{yhamnt}}</span></div>
            <div class="payBtn"></div>
          </Card>
          <div class="footer">
            <span :style="{marginRight:'40px'}">
              应付金额：
              <span :style="{color:'#ff7f0d',fontSize:'30px'}">¥{{info.payAmount&&info.payAmount.toFixed(2)}}元</span>
            </span>
            <Button
              type="primary"
              @click="gotopay"
              :style="{width:'100px'}"
            >去支付</Button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      css_detail: {
        position: 'relative',
        right: '-140px',
      },
      isShowLoading: false,
      info: {},
      articleId: this.$route.query.id,
      tradeNo: this.$route.query.tradeNo,
      orderID: this.$route.query.orderID,
      yhamnt: this.$route.query.yhamnt,
      payAmount: null,
      showCouponAmount: false
    };
  },
  created() {
    if(this.yhamnt){
      this.showCouponAmount = true;
    }
  },
  mounted () {
    this.gettravelDetail()
  },
  methods: {
    /**
     * 获取旅游卡详情
     **/
    gettravelDetail () {
      this.isShowLoading = true;
      this.$http.get(`${this.lee}/tourcard/tourcard/v1/getTourCard?${this.QS.stringify({
        access_token: sessionStorage.getItem('name'),
        usid: sessionStorage.getItem('userName'),
        cardId: this.articleId,

      })}`).then(res => {
        this.isShowLoading = false;
        var data = res.data;
        if (data.code === 200) {
          this.info = data.data.data
          if(this.showCouponAmount){
            this.info.payAmount = this.info.price - this.yhamnt;
          }else{
            this.info.payAmount = this.info.price;
          }
          this.status = data.data.own === 1 ? true : false
        } else {
          this.$Modal.warning({
            title: '温馨提示',
            content: data.msg
          });
        }
      });
    },
    /**
    * 跳转结算支付页面
    **/
    gotopay () {
      console.log(this.orderID, )
      this.isShowLoading = true;
      this.$http.get(`${this.lee}/ec/book/getReturnUrl?${this.QS.stringify({
        access_token: sessionStorage.getItem('name'),
        orid: this.orderID,
      })}`).then(res => {
        this.isShowLoading = false;
        var data = res.data;
        if (data.code !== 200) {
          this.$Modal.warning({
            title: '温馨提示',
            content: data.msg
          });
          return false;
        } else {
          window.location.href = data.msg
        }
      });
    }
  },
}
</script>

<style lang="less" scoped>
.travelCardpay {
  padding-bottom: 20px;
  .breadcrumb {
    width: 1400px;
    margin: 0 auto;
    line-height: 50px;
    margin-bottom: 10px;
  }
  .ticket_wrap {
    background: #fff;
    width: 1200px;
    margin: 30px auto 101px;
    padding: 10px 35px;
  }
}
p {
  margin-bottom: 10px;
}
.cardInfo {
  margin-top: 10px;
  border: 1px solid #e8eaec;
  padding: 10px;
  border-radius: 2px;
  p {
    margin-bottom: 10px;
    margin-left: 20px;
    color: #5e5e60;
    font-weight: 700;
    font-size: 14px;
    span {
      font-weight: 400;
      font-size: 12px;
    }
  }
}
.footer {
  font-size: 14px;
  text-align: right;
  margin-top: 10px;
  padding: 10px 0;
  strong {
    margin-right: 10px;
  }
}
.yhamout {
  font-size: 14px;
  text-align: right;
  padding: 10px 0;
  strong {
    margin-right: 10px;
  }
}
.payBtn {
  border-top: 1px solid #e8eaec;
  padding: 20px 0px 10px 0;
  font-size: 18px;
  text-align: right;
  margin-top: 10px;
}
</style>
